import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

const useProjects = (workspaceId: number) => useQuery(['projects', workspaceId], () => peApi.getProjects());

export default useProjects;
